import { Text } from '../primitives/Text.tsx';
import styles from './Brand.module.css';

/**
 * The product's own name, as a wordmark — optionally preceded by its mark.
 *
 * It is TYPOGRAPHY AND GEOMETRY, which is the design system's own position on
 * itself: § 10 says the system is entirely geometric and typographic and puts
 * any ILLUSTRATIVE direction outside it (§ 16). The mark respects that line —
 * it is the product's initial in the display family on a rounded tile, so
 * there is no drawn figure anywhere in it — and the name itself takes § 5.3's
 * gradient typography on a display step, which is exactly a short
 * high-salience string carrying the brand as its own colour.
 *
 * The tile's fill is `grad/mark`, and the reason that token exists rather than
 * one of § 4's ten being borrowed is written where it is defined
 * (tokens/gradient.css): every other gradient in the family carries a role,
 * and painting a logotype with one of them would say that role in the
 * masthead of every screen.
 *
 * Two sizes, and they are the two the scale already names. `sm` takes
 * `token-lg` — Gabarito's ≥26px floor (§ 5) rules out anything smaller, and
 * § 5.1 gives that step to "a short, high-salience string that IS the
 * content", which is what a wordmark is. `lg` takes `display-lg`, for the one
 * screen where the name is the subject rather than the letterhead.
 *
 * Lowercase, always: it is a proper noun set as a logotype, and § 5.2 forbids
 * uppercase above 12px in any case.
 */

interface BrandProps {
  size?: 'sm' | 'lg';
  /**
   * Whether the tile precedes the name. On by default in the application
   * shell, where the band is wide and the mark is what a returning learner
   * recognises; off where the name is already the subject of the screen.
   */
  mark?: boolean;
  /**
   * The heading level, where the wordmark IS the heading — the sign-in
   * screen. In the application shell it is a label on the page, not a
   * heading, and stays a `span`.
   */
  as?: 'span' | 'h1';
}

export function Brand({ size = 'sm', mark = false, as = 'span' }: BrandProps) {
  return (
    <span className={styles.brand} data-size={size}>
      {/* Decorative: the name it sits beside already says the same word, and
          § 12 has no use for hearing it twice. */}
      {mark ? (
        <span className={styles.mark} aria-hidden="true">
          c
        </span>
      ) : null}

      <Text as={as} variant={size === 'lg' ? 'display-lg' : 'token-lg'} tone="gradient">
        cavaquinho
      </Text>
    </span>
  );
}
